import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enUS from './locales/en-US.json';
import ar from './locales/ar.json';
import el from './locales/el.json';
import de from './locales/de.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import frCA from './locales/fr-CA.json';
import idID from './locales/id-ID.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ku from './locales/ku.json';
import pl from './locales/pl.json';
import ptBR from './locales/pt-BR.json';
import ptPT from './locales/pt-PT.json';
import ru from './locales/ru.json';
import tr from './locales/tr.json';

export const DEFAULT_LANG_CLIENT = 'en-US';

const resources = {
  ar: {
    translation: ar,
  },
  de: {
    translation: de,
  },
  el: {
    translation: el,
  },
  'en-US': {
    translation: enUS,
  },
  es: {
    translation: es,
  },
  fr: {
    translation: fr,
  },
  'fr-CA': {
    translation: frCA,
  },
  'id-ID': {
    translation: idID,
  },
  it: {
    translation: it,
  },
  ja: {
    translation: ja,
  },
  ko: {
    translation: ko,
  },
  ku: {
    translation: ku,
  },
  pl: {
    translation: pl,
  },
  'pt-BR': {
    translation: ptBR,
  },
  'pt-PT': {
    translation: ptPT,
  },
  ru: {
    translation: ru,
  },
  tr: {
    translation: tr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANG_CLIENT,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: resources,
    react: {
      useSuspense: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong'],
    },
    returnEmptyString: false,
  });

export default i18n;
